module.exports = __webpack_public_path__ + "static/media/1.f2f15283.jpeg";